/** Servers Gyro manages, by the key the desktop reports (compared ignoring case). */
const KNOWN = {
    'gyro-ai-for-revit': 'Gyro AI for Revit',
    // The spelling agents up to 0.4.9.4 registered: the same server.
    'revit-ai': 'Gyro AI for Revit',
    bluebeam: 'Bluebeam',
};
const CONTROL_OR_BIDI = /[؜‎‏‪-‮⁦-⁩\u0000-\u001f\u007f]/gu;
/** A model-chosen server or tool name as a line may show it: no bidi or control characters, at most 60 characters. */
export function shownMcpName(name) {
    const clean = String(name ?? '').replace(CONTROL_OR_BIDI, '').trim();
    return clean.length > 60 ? `${clean.slice(0, 59)}…` : clean;
}
/** The display name of `server`, from the snapshot first, else the known list; undefined when it has none. */
export function mcpServerDisplayName(server, servers) {
    if (typeof server !== 'string' || !server.trim())
        return undefined;
    const key = server.trim().toLowerCase();
    const listed = servers?.find((entry) => entry.name.toLowerCase() === key);
    if (listed?.displayName)
        return listed.displayName;
    return KNOWN[key];
}
/** The display name when there is one, else the key itself (shaped for a line). */
export function mcpServerLabel(server, servers) {
    return mcpServerDisplayName(server, servers) ?? shownMcpName(server);
}
/**
 * An action's summary as the person reads it: for a call to one of the PC's MCP servers, "Run <tool> on <display name>"
 * built from the action's own input (so a summary an older service wrote with the key is shown with the name); any other
 * action keeps the summary the service gave it.
 */
export function mcpActionSummary(action, servers) {
    if (action.tool !== 'mcp_call' || !action.input || typeof action.input !== 'object')
        return action.summary;
    const { server, tool } = action.input;
    if (typeof server !== 'string' || !server.trim() || typeof tool !== 'string' || !tool.trim())
        return action.summary;
    return `Run ${shownMcpName(tool)} on ${mcpServerLabel(server, servers)}`;
}
//# sourceMappingURL=mcpDisplayNames.js.map